"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconBankidNor = function IconBankidNor(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M5.817 15.538h7.273v-.003c.968 0 1.817-.826 1.817-1.768 0-.941-.846-1.767-1.817-1.767H5.817C4.849 12 4 12.829 4 13.77s.846 1.768 1.817 1.768m0 14.148h7.273c.968 0 1.817-.826 1.817-1.767 0-.942-.846-1.768-1.817-1.768H5.817c-.968 0-1.817.826-1.817 1.768 0 .941.846 1.767 1.817 1.767m7.273 7.076H5.817c-.971 0-1.817-.826-1.817-1.767 0-.942.85-1.768 1.817-1.768h7.273c.97 0 1.817.826 1.817 1.768 0 .94-.85 1.767-1.817 1.767m7.273-14.149h7.274c.967 0 1.816-.825 1.816-1.767 0-.941-.845-1.767-1.816-1.767h-7.274c-.967 0-1.816.826-1.816 1.767 0 .942.846 1.767 1.816 1.767m7.274 7.073h-7.274c-.97 0-1.816-.826-1.816-1.767 0-.942.849-1.768 1.816-1.768h7.274c.97 0 1.816.826 1.816 1.768 0 .941-.849 1.767-1.816 1.767m7.27-14.148h7.273c.968 0 1.817-.826 1.817-1.767 0-.942-.846-1.768-1.817-1.768h-7.273c-.968 0-1.817.826-1.817 1.768 0 .94.846 1.767 1.817 1.767m7.273 7.075h-7.273c-.971 0-1.817-.825-1.817-1.767 0-.941.85-1.767 1.817-1.767h7.273c.971 0 1.817.826 1.817 1.767 0 .942-.85 1.767-1.817 1.767m-7.273 14.149h7.273c.968 0 1.817-.826 1.817-1.767 0-.942-.846-1.768-1.817-1.768h-7.273c-.968 0-1.817.826-1.817 1.768 0 .94.846 1.767 1.817 1.767",
    clipRule: "evenodd"
  })));
};

export { IconBankidNor, IconBankidNor as default };
